/* eslint-disable */
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray } from '../../utils';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../restClient';
// children
import Radio from '../common/Radio/radioButton';
import Table from '../common/Table/';
import Tooltip from '../common/Tooltip';
import { IgnoreCaseModal } from './Modals';
//action Creator
import { setEntityToNoConflictStatus, updateEntity } from '../createAcase/actions/actionCreator';
import { setDarkTitleBarContent } from '../layouts/actions/actionCreator';
import { setInFlightCasesStateForEntity } from './actions/actionCreator';
//style
import './styles.css';

class GenerateListItem extends Component {
  state = {
    showTooltip: false
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  showTooltip = () => {
    this.setState({
      showTooltip: true
    })
  }

  hideTooltip = () => {
    this.setState({
      showTooltip: false,
    })
  }

  toolTipToggel = () => {
    this.setState(prevState => {
      showTooltip: !prevState.showTooltip
    });
  }

  render() {
    const displayData = this.props.data.slice(0, 3);
    const listData = this.props.data.slice(displayData.length);
    return (
      <div>
        {
          displayData.map(item =>
            <li
              key={item.productId}
            >
              {item.name}{item.country !== null ? ', ' : ''}{item.country}
            </li>
          )
        }
        {
          listData.length > 0
            ? <li>
              <a
                className="more-tooltip"
                data-tooltip={`case-ids_${this.props.currentId}`}
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
              >
                {`+${listData.length} more`}
              </a>
              <Tooltip
                active={this.state.showTooltip}
                position="bottom"
                arrow="center"
                parent={`case-ids_${this.props.currentId}`}
              >
                <ul className="tooltip-content-list">
                  {
                    listData.map(item =>
                      <li
                        key={item.productId}
                      >
                        {item.name}{item.country !== null ? ', ' : ''}{item.country}
                      </li>
                    )
                  }
                </ul>
              </Tooltip>
            </li>
            : ''
        }

      </div>
    )
  }
}

class ViewEntityProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inFlightCases: [],
      inFlightCasesState: {},
      updatedInFlightCasesState: {},
      customerDetails: {},
      serviceHistory: [],
      showTooltip: false,
      showIgnoreCaseDialog: false,
      isIgnoreCase: undefined,
      inflightData: {},
      gdocTermsStatus: {},
      meta: [],
      resetInflightcase: true,
      infligtIds: []
    };

  };

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }


  toolTipToggel = () => {
    this.setState(prevState => {
      showTooltip: !prevState.showTooltip
    });
  }

  toggleDialog = () => {
    this.setState({
      showIgnoreCaseDialog: false,
      showMarkAsCompletedDialog: false
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.inFlightState !== undefined && this.state.resetInflightcase) {
      if (Object.keys(nextProps.inFlightState).length === this.state.inFlightCases.length) {
        this.props.setEntityToNoConflictStatus(this.props.match.params.entityId);
        this.setState({
          ...this.state,
          resetInflightcase: false
        })
      }
    }

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      let meta = [{
        displayName: convertStringToArray(Translations(this.state.pageJson.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[0],
        key: "caseNumber",
        type: "String",
        defaultValue: "N/A"
      }, {
        displayName: convertStringToArray(Translations(this.state.pageJson.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[1],
        key: "outputDocumentType",
        type: "String",
        defaultValue: "N/A"
      }, {
        displayName: convertStringToArray(Translations(this.state.pageJson.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[2],
        key: "product",
        type: "String",
        defaultValue: "N/A"
      }, {
        displayName: convertStringToArray(Translations(this.state.pageJson.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[3],
        key: "country",
        type: "String",
        defaultValue: "N/A"
      }, {
        displayName: convertStringToArray(Translations(this.state.pageJson.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[4],
        key: "negotiation",
        type: "String",
        defaultValue: "N/A"
      }];

      this.setState({ meta });
    }
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getAccountCountryTaxanomy();
    }
  }

  getAccountCountryTaxanomy = () => {
    let customerDetails = this.state.customerDetails;
    taxonomyHostClient(this.translations(this.state.pageJson.par.text_data_customerBasicDetails.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let countryListTaxonomy = data.responseData.countryTaxonomy.classificationNodes;
          countryListTaxonomy.filter(countItem => {
            if ('countryOfIncorporation' in customerDetails) {
              if (countItem.id === customerDetails.countryOfIncorporation.value) {
                customerDetails.countryOfIncorporation.name = countItem.name
              }
            }
            if ('countryOfRegistration' in customerDetails) {
              if (countItem.id === customerDetails.countryOfRegistration.value) {
                customerDetails.countryOfRegistration.name = countItem.name
              }
            }
            return customerDetails;
          })
          this.setState({ customerDetails })
        }

      })

  }

  submitRequest = () => {
    //this.toggleDialog()
    const infligtIds = this.state.infligtIds;
    const arrFlight = infligtIds.sort((a, b) => Number(a.id) - Number(b.id));
    if (this.state.inFlightCases.length === this.state.infligtIds.length) {
      const flightData = arrFlight.reduce((obj, item) => (obj[item.key] = item.value, obj), {});
      this.setState({
        updatedInFlightCasesState: {
          ...flightData
        }, showIgnoreCaseDialog: false
      }, function () {
        this.props.setInFlightCasesStateForEntity(this.props.match.params.entityId, this.state.updatedInFlightCasesState);
      });
    } else {
      this.setState({
        updatedInFlightCasesState: {
          ...this.state.updatedInFlightCasesState,
          [this.state.inflightData.value]: this.state.inflightData.id
        }, showIgnoreCaseDialog: false
      }, function () {
        this.props.setInFlightCasesStateForEntity(this.props.match.params.entityId, this.state.updatedInFlightCasesState);
      });
    }
  }

  openModal = (id, value, index) => {
    var inflightData = { id: id, value: value }
    let infligt = [...this.state.infligtIds, { id: index, key: value, value: id }]
    let isIgnoreCase
    if (id === 'ignore') {
      isIgnoreCase = true;
    }
    else {
      isIgnoreCase = false;
    }
    this.setState({ showIgnoreCaseDialog: true, isIgnoreCase: isIgnoreCase, inflightData: inflightData, infligtIds: infligt })
  }

  getInputValue(id, value, name) {
    this.setState({
      inFlightCasesState: {
        ...this.state.inFlightCasesState,
        [id]: value
      }
    });
  }

  componentWillMount() {
    aemHostClient('/aemData/formData/json_entity-profile')
      .then(({ data, status }) => {
        this.setState({ pageJson: data });
        eapiClient('/entities/organisations/' + this.props.match.params.entityId)
          .then(({ data, status }) => {
            this.setState({ customerDetails: data.responseData }, () => {
              this.props.updateEntity(data.responseData.id, data.responseData);
              this.getAccountCountryTaxanomy();
            })
          });
        document.title = `${data.title} - ${'HSBC GLCM'}`;
        if (data !== undefined) {
          let meta = [{
            displayName: convertStringToArray(Translations(data.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[0],
            key: "caseNumber",
            type: "String",
            defaultValue: "N/A"
          }, {
            displayName: convertStringToArray(Translations(data.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[1],
            key: "outputDocumentType",
            type: "String",
            defaultValue: "N/A"
          }, {
            displayName: convertStringToArray(Translations(data.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[2],
            key: "product",
            type: "String",
            defaultValue: "N/A"
          }, {
            displayName: convertStringToArray(Translations(data.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[3],
            key: "country",
            type: "String",
            defaultValue: "N/A"
          }, {
            displayName: convertStringToArray(Translations(data.par.table_glsApprovalsCaseList.fieldLabels, this.props.lang.currentLang.lang, this.props.lang.translatedData))[4],
            key: "negotiation",
            type: "String",
            defaultValue: "N/A"
          }];

          this.setState({ meta });
        }
      });

    eapiClient('/cases/serviceHistory/' + this.props.match.params.entityId)
      .then(({ data, status }) => {
        this.setState({ serviceHistory: Array.isArray(data.responseData) ? data.responseData : [] })
      });



    eapiClient('/cases/' + this.props.match.params.entityId + '/inFlight')
      .then(({ data, status }) => {
        this.setState({ inFlightCases: data.responseData });
      });

    eapiClient('/cases/entity/' + this.props.match.params.entityId + '/entityStatus')
      .then(({ data, status }) => {
        this.setState({ gdocTermsStatus: data.responseData });
      });
  }

  componentDidMount() {
    this.props.setDarkTitleBarTitle(this.props.entities[this.props.match.params.entityId] ? this.props.entities[this.props.match.params.entityId].entityName : '');
    this.setState({
      inFlightCasesState: this.props.inFlightState || {}
    });
  }

  goToSelectEntityPage = () => {
    this.props.history.goBack();
  }

  goToEditEntityPage = () => {
    this.props.history.push('/create-a-case/edit-entity', { mode: 'edit', entityId: this.state.customerDetails.id });
  }


  getGdocsTerms = (negotiation) => {
    if (negotiation === undefined) {
      return (<span>New to GDocs</span>)
    } else if (negotiation) {
      return (<span>Negotiated <i className="icon icon-circle-error-solid gdoc-actnReqRelated"></i></span>)
    } else {
      return (<span>Standard</span>)
    }
  }

  showTooltip = () => {
    this.setState({
      showTooltip: true
    })
  }

  hideTooltip = () => {
    this.setState({
      showTooltip: false,
    })
  }

  renderInFlightCases = () => {
    return this.state.inFlightCases.map((inFlightCase, index) => (
      <div className="in-flight-case-section" key={inFlightCase.id}>
        <div className="in-flight-case-details">
          <div className="col-md-4 case-details-col">
            <ul>
              <li className="heading">{`${this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.fieldLabels)[0]}: ${inFlightCase.caseId}`}</li>
              <li>{`${this.translations(this.state.pageJson.par.static_text_basicDetails.created)}: ${moment(inFlightCase.createdOn).format("DD MMM YY")}`}</li>
              <li><b>{`${this.translations(this.state.pageJson.par.static_text_basicDetails.status)}: ${inFlightCase.statusValue}`}</b></li>
            </ul>
          </div>
          <div className="col-md-4 case-products-col">
            <ul>
              <li className="heading">{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.fieldLabels)[1]}</li>
              {
                <GenerateListItem data={inFlightCase.productDatas} currentId={index} />
              }
            </ul>
          </div>
          <div className="col-md-4 case-owner-col">
            <ul>
              <li className="heading">{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.fieldLabels)[2]}</li>
              <li><b>{inFlightCase.caseOwner.name}</b></li>
              <li>{inFlightCase.caseOwner.value}</li>

            </ul>
          </div>
        </div>
        <div className="vl"></div>
        <div className="case-actions-container">
          <div className="optionBtn">
            <Radio
              name={`${inFlightCase.id}_case_action`}
              value="ignore"
              _value={this.state.inFlightCasesState[inFlightCase.id]}
              setInputvalue={this.getInputValue.bind(this, inFlightCase.id)}
            />
            <label>{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.radioOptions)[0]}</label>
          </div>
          <div>
            <Radio
              name={`${inFlightCase.id}_case_action`}
              value="treat_as_completed"
              _value={this.state.inFlightCasesState[inFlightCase.id]}
              setInputvalue={this.getInputValue.bind(this, inFlightCase.id)}
            />
            <label>{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.radioOptions)[1]}</label>
          </div>
        </div>
        <div className="case-actions-container-button">
          <button aria-label="Add account" className="gdocs-btn-submit-btn ignore-btn" disabled={!this.state.inFlightCasesState[inFlightCase.id]} onClick={this.openModal.bind(this, this.state.inFlightCasesState[inFlightCase.id], inFlightCase.id, index)}>
            {this.translations(this.state.pageJson.par.button_submit.name)}
          </button>
        </div>
      </div>
    ));
  }


  render() {

    return (
      (this.state.pageJson !== undefined ?
        <div className="view-entity-container-area">
          <div className="view-entity-container">
            {/* {this.state.inFlightCases.length > 0 ?
              <h2 className="in-flight-case-heading">
                {this.translations(this.state.pageJson.par.in_flight_case_inFlightCases.title)}
                <i
                  className="icon icon-circle-info gdocs-valign-middle gdocs-mleft-5"
                  data-tooltip="inFlight"
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                ></i>
                <Tooltip
                  active={this.state.showTooltip}
                  position="bottom"
                  arrow="center"
                  parent="inFlight"
                > 
                <ul className="tooltip-content-list-inflight">
                  <li>{this.translations(this.state.pageJson.par.notification_bannerText.message)}</li>
                  <li>
                    <strong>{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.radioOptions)[0]}</strong>
                    {this.translations(this.state.pageJson.par.notification_bannerText.message1)}
                  </li>
                  <li>
                    <strong>{this.translateWord(this.state.pageJson.par.in_flight_case_inFlightCases.radioOptions)[1]}</strong>
                    {this.translations(this.state.pageJson.par.notification_bannerText.message2)}
                  </li>
                </ul>
              </Tooltip>
              </h2> : ''} */}
            <div className="in-flight-cases-container">
              {/* {this.renderInFlightCases()} */}
              <IgnoreCaseModal
                showDialog={this.state.showIgnoreCaseDialog}
                pageJson={this.state.pageJson}
                toggleDialog={this.toggleDialog}
                submitRequest={this.submitRequest.bind(this)}
                isIgnoreCase={this.state.isIgnoreCase}
                bsClass="gdocs-other-products-list-dialog"
                translations={(word) => this.translations(word)}
              />
            </div>
            <div className="customer-basic-details-container">
              <h4>{this.translations(this.state.pageJson.par.text_data_customerBasicDetails.title)}</h4>
              <ul className="customer-details">
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[0]}</label>
                  {
                    this.state.gdocTermsStatus.gdocsTerms
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[2]}</label>
                  {
                    this.state.customerDetails['countryOfIncorporation']
                      ? this.state.customerDetails['countryOfIncorporation'].name
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[3]}</label>
                  {
                    this.state.customerDetails['countryOfRegistration']
                      ? this.state.customerDetails['countryOfRegistration'].name
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[4]}</label>
                  {
                    this.state.customerDetails['incorporationNumber'] !== ""
                      ? this.state.customerDetails['incorporationNumber']
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[6]}</label>
                  {
                    this.state.customerDetails['taxNumber'] !== ""
                      ? this.state.customerDetails['taxNumber']
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[7]}</label>
                  {
                    this.state.customerDetails['corpStatus'] !== ""
                      ? this.state.customerDetails['corpStatus']
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[8]}</label>
                  {
                    this.state.customerDetails['businessSegment']
                      ? this.state.customerDetails['businessSegment'].name
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[11]}</label>
                  {
                    this.state.customerDetails['glcmImplementation'] !== ""
                      ? (this.state.customerDetails['glcmImplementation'] === true
                        ? this.translations(this.state.pageJson.par.button_yes.name)
                        : this.translations(this.state.pageJson.par.button_no.name)
                      )
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>

                {this.state.customerDetails['glcmImplementation'] === true ?
                  <React.Fragment>
                    <li>
                      <label>ClientSphere Project Number/CMP Project ID</label>
                      {
                        this.state.customerDetails['projectNo'] ?
                          (this.state.customerDetails['projectNo'] === "CS"
                            ? "ClientSphere Project Number"
                            : "CMP Project ID"
                          )
                          : this.translations(this.state.pageJson.par.static_text_s.type)
                      }
                    </li>
                    {this.state.customerDetails['projectNo'] === "CS" ? <li>
                      <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[12]}</label>
                      {
                        this.state.customerDetails['csProjectNumber'] !== ""
                          ? this.state.customerDetails['csProjectNumber']
                          : this.translations(this.state.pageJson.par.static_text_s.type)
                      }
                    </li> :
                      <li>
                        <label>CMP Project ID</label>
                        {
                          this.state.customerDetails['cmpProjectID'] ||
                          this.translations(this.state.pageJson.par.static_text_s.type)
                        }
                      </li>}
                  </React.Fragment>
                  : null}

                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[9]}</label>
                  {
                    this.state.customerDetails['financialInstitution'] !== ""
                      ? (this.state.customerDetails['financialInstitution'] === true
                        ? this.translations(this.state.pageJson.par.button_yes.name)
                        : this.translations(this.state.pageJson.par.button_no.name)
                      )
                      : this.translations(this.state.pageJson.par.static_text_s.type)
                  }
                </li>
                <li>
                  <label>{this.translateWord(this.state.pageJson.par.text_data_customerBasicDetails.fieldLabels)[10]}</label>
                  {
                    this.state.customerDetails['txtGRIDno'] !== ""
                      ? this.state.customerDetails['txtGRIDno']
                      : "N/A"
                  }
                </li>
              </ul>
              <button onClick={this.goToEditEntityPage} style={{ display: 'none' }}>{this.translations(this.state.pageJson.par.button_editBasicDetails.text)}</button>
              <p className="note">* {this.translations(this.state.pageJson.par.static_text_basicDetails.description)}</p>
            </div>
            <hr></hr>
            <div className="service-history-container">
              <h4>{this.translations(this.state.pageJson.par.table_glsApprovalsCaseList.title)}</h4>
              <Table
                className="service-history-table"
                data={this.state.serviceHistory || []}
                useObjectKeys={false}
                tableMeta={this.state.meta}
              />
            </div>
            <button className="godc-flt-rgt gdocs-btn-submit-btn" onClick={this.goToSelectEntityPage}>{this.translations(this.state.pageJson.par.button_backToCase.text)}</button>
          </div>
        </div >
        : ''));
  }

  // componentWillUnmount() {
  //
  // }
}

const mapStateToProps = (state, props) => {
  return {
    entities: state.entities,
    inFlightState: state.inFlightCasesState[props.match.params.entityId],
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarTitle: pageTitle => {
      dispatch(setDarkTitleBarContent(pageTitle));
    },
    updateEntity: (entityId, entityData) => {
      dispatch(updateEntity(entityId, entityData));
    },
    setInFlightCasesStateForEntity: (entityId, inFlightState) => {
      dispatch(setInFlightCasesStateForEntity(entityId, inFlightState));
    },
    setEntityToNoConflictStatus: entityId => {
      dispatch(setEntityToNoConflictStatus(entityId));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewEntityProfile);



// WEBPACK FOOTER //
// ./src/components/ViewEntityProfile/index.js